module.exports = __webpack_public_path__ + "img/proposal1.99ffc0b7.jpeg";